module.exports = __webpack_public_path__ + "img/team-member-09.910cd93f.jpg";